import { useEffect, useState } from "react";
import { Form, Input, Modal, ModalProps } from "antd";
import { Tactic } from "../../../../types/TacticTypes";

interface TacticEditModalProps extends Omit<ModalProps, "onOk"> {
    data?: Tactic;
    onOk?: (data: Tactic) => void | Promise<void>;
}

export const TacticEditModal: React.FC<TacticEditModalProps> = ({ data, onOk, ...restProps }) => {
    const [form, setForm] = useState({} as Tactic);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!data) return;
        setForm(data);
    }, [data]);

    const handleOk = async () => {
        if (!onOk) return;
        setLoading(true);
        try {
            await onOk(form);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal {...restProps} confirmLoading={loading} onOk={handleOk}>
            <Form>
                <Form.Item label="Name" required>
                    <Input
                        value={form.name}
                        onChange={(e) =>
                            setForm((old) => ({
                                ...old,
                                name: e.target.value,
                            }))
                        }
                    />
                </Form.Item>
                <Form.Item label="Content" required>
                    <Input.TextArea
                        rows={30}
                        value={form.content}
                        onChange={(e) =>
                            setForm((old) => ({
                                ...old,
                                content: e.target.value,
                            }))
                        }
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};
